import { BundleProgressBar } from 'modules/billing/components/BundleProgressBar';
import { ChargingModel } from 'modules/billing/types';

export interface ProgressBarProps {
  chargingModel: ChargingModel | undefined;
}

export const ProgressBar = ({ chargingModel }: ProgressBarProps) => {
  const hasProgressBar =
    chargingModel?.type === 'deal' ||
    chargingModel?.type === 'freemium' ||
    chargingModel?.type === 'package';

  if (!hasProgressBar) {
    return null;
  }

  return <BundleProgressBar chargingModel={chargingModel} isShortened />;
};
